import authAxios from "../common/authAxios";
import { PodpishiDocDtoResponse } from "../interfaces/PodpishiDto";

export class SignService {
    static getPodpishiDocument() {
        return authAxios.get<PodpishiDocDtoResponse>(
            `/astanait-sign-module/api/v1/podpishi/doc`
        ).then(response => {
            return response.data && "http://api.podpishi.kz/qr.php?id1=" + response.data.podpishiDocName + "&id2=" + response.data.podpishiDocHash;
        });
    }

    static getPodpishiDocumentByUserId(userId: number) {
        return authAxios.get<PodpishiDocDtoResponse>(
            `/astanait-sign-module/api/v1/podpishi/doc/user/${userId}`
        ).then(response => {
            return response.data && "http://api.podpishi.kz/qr.php?id1=" + response.data.podpishiDocName + "&id2=" + response.data.podpishiDocHash;
        });
    }

    static getPodpishiDocumentById(id: number) {
        return authAxios.get<PodpishiDocDtoResponse>(
            `/astanait-sign-module/api/v1/podpishi/doc/${id}`
        );
    }
}